import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";
import { constructQueryString } from "../../Util/HelperFunction";

export const studentListAction = createAsyncThunk(
    'student/list', async (reqBody, thunkAPI) => {
        try {
            const query = constructQueryString(reqBody)
            const response = await Api.get(`/student/list?${query}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })



    export const studentCsvListAction = createAsyncThunk(
        'student/Csvlist', async (reqBody, thunkAPI) => {
            try {
                const query = constructQueryString(reqBody)
                const response = await Api.get(`/student/csv/download?${query}`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    



export const studentCollectionListAction = createAsyncThunk(
    'student/collection', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`/student/collection?id=${reqBody.id}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })


    export const avatarAction = createAsyncThunk(
        'student/avatar', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.get(`/auth/avatar`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    

    



    export const studentEditAction = createAsyncThunk(
        'student/edit', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.put('student/edit', reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    
    
    

    export const studentCreateAction = createAsyncThunk(
        'student/create', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.post('student/create', reqBody)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })
    




        export const weelklyLoginStudentAction = createAsyncThunk(
            'student/studentLogin',
            async (reqBody, thunkAPI) => {
              try {
                const { id, date } = reqBody;
                let url = `/student/active-hours`;
          
                const params = new URLSearchParams();
          
                if (id) params.append('id', id);
                if (date?.startOfWeek) params.append('startOfWeek', date.startOfWeek);
                if (date?.endOfWeek) params.append('endOfWeek', date.endOfWeek);
          
                if (params.toString()) {
                  url += `?${params.toString()}`;
                }
          
                const response = await Api.get(url);
                return response.data;
              } catch (error) {
                return thunkAPI.rejectWithValue(error.response?.data || error.message);
              }
            }
          );



            export const weelklySchoolAdminAction = createAsyncThunk(
            'schoolAdmin/schoolAdminLogin',
            async (reqBody, thunkAPI) => {
              try {
                const { id, date } = reqBody;
                let url = `/school/schoolAdmin-activehours`;
          
                const params = new URLSearchParams();
          
                if (id) params.append('id', id);
                if (date?.startOfWeek) params.append('startOfWeek', date.startOfWeek);
                if (date?.endOfWeek) params.append('endOfWeek', date.endOfWeek);
          
                if (params.toString()) {
                  url += `?${params.toString()}`;
                }
          
                const response = await Api.get(url);
                return response.data;
              } catch (error) {
                return thunkAPI.rejectWithValue(error.response?.data || error.message);
              }
            }
          );


          



        export const weelklyWatchedVideoStudentAction = createAsyncThunk(
            'student/studentWatchCount',
            async (reqBody, thunkAPI) => {
              try {
                const queryParams = new URLSearchParams();
          
                if (reqBody?.id) {
                  queryParams.append('id', reqBody.id);
                }
          
                if (reqBody?.date?.startOfWeek) {
                  queryParams.append('startOfWeek', reqBody.date.startOfWeek);
                }
          
                if (reqBody?.date?.endOfWeek) {
                  queryParams.append('endOfWeek', reqBody.date.endOfWeek);
                }
          
                const response = await Api.get(`/student/Video-Watched?${queryParams.toString()}`);
                return response.data;
              } catch (error) {
                return thunkAPI.rejectWithValue(error.response?.data || error.message);
              }
            }
          );
          
    

    export const studentClassListAction = createAsyncThunk(
        'student/class', async (reqBody, thunkAPI) => {
            try {
                const response = await Api.get(`/student/class?id=${reqBody.id}`)
                return response.data
            } catch (error) {
                return thunkAPI.rejectWithValue(error.response.data);
            }
        })

        export const studentDeleteAction = createAsyncThunk(
            'student/delete', async (reqBody, thunkAPI) => {
                try {
                    const response = await Api.delete(`/student/delete?id=${reqBody.id}`)
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })
            
        

        

        export const studentSuspendAction = createAsyncThunk(
            'student/suspend', async (reqBody, thunkAPI) => {
                try {
                    const response = await Api.post(`/student/suspend`,reqBody)
                    return response.data
                } catch (error) {
                    return thunkAPI.rejectWithValue(error.response.data);
                }
            })
    
        

        
    
export const studentdetailsAction = createAsyncThunk(
    'student/details', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.get(`/student/details?id=${reqBody.id}`)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

export const studentResetPassAction = createAsyncThunk(
    'student/reset-password', async (reqBody, thunkAPI) => {
        try {
            const response = await Api.put(`student/reset-password`, reqBody)
            return response.data
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    })

